import { FC } from 'react';

import { useOnboardingHook } from 'views/onboarding-flow';

import './label.scss';

interface ILabel {
	label?: string;
	priceLabel?: string;
	price?: number;
	/**
	 * __simplici_condition_label_range__
	 * Upper bound, for a step whose cost is not decided until the session runs
	 * (the investor picks their accreditation level). Given this, the row renders
	 * a range rather than a single figure. Omitted by every other tile.
	 */
	max?: number;
	/**
	 * __simplici_condition_label_locked_box__
	 * Render a checked, disabled checkbox on this row.
	 *
	 * The KYB tile's first row is the step itself — always included, never
	 * optional — while the rows beneath it are purchasable extras that each
	 * carry a box. Without one here the first row's price sat where the others'
	 * did but the column of boxes started a row late, so the tile looked
	 * ragged. A locked box keeps the column true and says plainly that this one
	 * is not a choice. Omitted by every other tile.
	 */
	lockedBox?: boolean;
}
export const Label: FC<ILabel> = ({ label, price, priceLabel, max, lockedBox }) => {
	// Only a genuinely higher bound is a range; otherwise fall through to the
	// single-figure rendering every other tile relies on.
	const upper = Number(max ?? 0);
	const isRange = Number.isFinite(upper) && upper > Number(price ?? 0);
	const { isPricingHide } = useOnboardingHook();

	return (
		<div
			className={`condition-label ${
				label === 'esign' ? 'condition-label__esign' : ''
			}`}
		>
			<div className="left">{label}</div>
			{lockedBox && (
				<input
					type="checkbox"
					className="nodrag condition-label__locked"
					checked
					disabled
					readOnly
					aria-label={`${label} is always included`}
					title="Always included — this is the step itself"
				/>
			)}
			{isPricingHide && price && (
				<div className="right">
					<span>
						${price?.toFixed(2)}
						{isRange && <> &ndash; ${upper.toFixed(2)}</>}
					</span>
					/{priceLabel}
				</div>
			)}
		</div>
	);
};
